import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import CompanyIcon from '@mui/icons-material/Business'; // Ícone de exemplo; substitua pelo ícone da sua empresa

interface HeaderProps {
  title: string;
}

const HeaderWithoutMenu: React.FC<HeaderProps> = ({ title }) => {
  return (
    <AppBar position="static" sx={{ width: '100%' }}>
      <Toolbar>
        {/* Ícone à esquerda */}
        <Box display="flex" alignItems="center" sx={{ mr: 'auto' }}>
          <CompanyIcon fontSize="large" />
        </Box>

        {/* Título centralizado */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: 'center' }}>
          Backup Fácil - {title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderWithoutMenu;
